import React, { useEffect, useState } from "react";
import "./Utilization.css"; // Assuming you will create a CSS file for styling
import "./RightNow.css";
import {
  Button,
  DataItem,
  Dialog,
  DropdownMenu,
  FooterAction,
  Item,
} from "@deere/isg.component-library";
import useApiCall from "../../../../hooks/useApiCall";
import { hasPermission } from "../../../../../permissions";
import { AppContext } from "../../../../context/AppContext";
import {
  Clock,
  IconAutomation,
  IconError,
  IconMarkerEmpty,
  IconPause,
  IconRefresh,
  StatusAutonomyActive,
  StatusAutonomyOff,
  StatusAutonomyReady,
  StatusEquipmentWorking,
} from "@deere/icons/new";
import { scaleGeoPointsToSvg } from "../../../utils/scaleGeoPoints";
import { resolveTaskLocations } from "../../../utils/resolveTaskLocations";
import HeartbeatTimeline from "./HeartbeatTimeline";

// const backendURI = '18.219.96.136/API';
const backendURI = process.env.REACT_APP_STRIPPED_BACKEND_URI;

interface PolylineProps {
  points: string; // A string representing the points of the polyline
  stroke?: string; // Optional stroke color for the line
  strokeWidth?: number; // Optional stroke width for the line
}

const Polyline: React.FC<PolylineProps> = ({
  points,
  stroke = "black", // Default stroke color
  strokeWidth = 2, // Default stroke width
}) => {
  return (
    <svg width="32" height="32" viewBox="0 0 200 200">
      <polyline points={points} fill="none" stroke={stroke} strokeWidth={strokeWidth} />
    </svg>
  );
};

interface PolygonProps {
  points: string; // A string representing the points of the polygon, e.g., "50,150 100,50 150,150"
  fill?: string; // Optional fill color for the polygon
  stroke?: string; // Optional stroke color for the polygon
  strokeWidth?: number; // Optional stroke width for the polygon
}

const Polygon: React.FC<PolygonProps> = ({
  points,
  fill = "lightblue", // Default fill color
  stroke = "black", // Default stroke color
  strokeWidth = 1, // Default stroke width
}) => {
  return (
    <svg width="32" height="32" viewBox="0 0 200 200">
      <polygon points={points} fill={fill} stroke={stroke} strokeWidth={strokeWidth} />
    </svg>
  );
};

interface MissionStatusTrackingProps {
  timeUntilFinish: string; // e.g., "46 min to finish 23.5 miles"
  stepsCompleted: number; // Number of steps completed
  totalSteps: number; // Total number of steps
  nextAction: string; // e.g., "Next: Load Zone A"
  completionTime: string; // e.g., "3:14 PM"
}

const MissionStatusTracking: React.FC<MissionStatusTrackingProps> = ({
  timeUntilFinish,
  stepsCompleted,
  totalSteps,
  nextAction,
  completionTime,
}) => {
  const progressPercentage = (stepsCompleted / totalSteps) * 100;
  console.log("Mission Status:", stepsCompleted);
  console.log("Mission Goal:", totalSteps);

  return (
    <div className="missionStatusTracking">
      {/* Time Until Finish */}
      <div className="timeUntilFinish">{timeUntilFinish} to finish</div>
      {/* Progress Bar */}
      <div className="progressContainer">
        <div className="progressBar" style={{ width: `${progressPercentage}%` }} />
      </div>
      <div className="progressText">{/* {stepsCompleted} / {totalSteps} steps completed */}</div>
      {/* Next Action */}
      <div className="nextAction">Destination: {nextAction}</div>
      {/* Completion Time */}
      <div className="completionTime">
        <Clock size={16} style={{ marginRight: "6px" }} /> {completionTime}
      </div>
    </div>
  );
};

// With props:
type Props = {
  orgDataSession: any;
  userLocation: any;
  setUserLocation: (loc: any) => void;
  isSpoofing: boolean;
  setIsSpoofing: (val: boolean) => void;
  originalLocation: any;
  setOriginalLocation: (loc: any) => void;
  equipObject: any;
  autonomyStatus: any;
  navigatorStatus: any;
  orgData: any;
  curEquipment: any;
  currentTopicString: any;
  orgName?: string;
};

const checkStatus = true;

const RightNow: React.FC<Props> = (props) => {
  const { user } = React.useContext(AppContext);
  const role = user.role;
  const orgName = props.orgName || "";

  const [missionsObjects, setMissionsObjects] = useState<any>([]);
  const [missions, setMissions] = useState<any>([]);
  const [locations, setLocations] = useState<any[]>();
  const [locationItems, setLocationItems] = useState<any[]>([]);
  const [filteredMissions, setFilteredMissions] = useState<any>([]);
  const [curMissionObj, setCurMissionObj] = useState<any>({});
  const [autonomyIcon, setAutonomyIcon] = useState<any>(<StatusAutonomyOff size={32} />);
  const [autonomyState, setAutonomyState] = useState<string>("Off");
  const [navigatorState, setNavigatorState] = useState<string>("Off");
  const [engineState, setEngineState] = useState<string>("Off");
  const [equipLocation, setEquipLocation] = useState<any>();
  const [isWithinRange, setIsWithinRange] = useState<any>(false);
  const [isErrorWindowOpen, setErrorWindowOpen] = useState(false);
  const [hasErrors, setHasErrors] = useState(false);
  const [canGiveCommand, setCanGiveCommand] = useState(false);
  const [errorListItems, setErrorListItems] = useState<any>([]);
  const [isActive, setIsActive] = useState<boolean>(false);
  const [currentTab, setCurrentTab] = useState<string>("1");

  const [taskList, setTaskList] = useState<any>([]);
  const [showClearTasksConfirm, setShowClearTasksConfirm] = useState(false);
  const { execute } = useApiCall({ errorAsToast: true });
  const [loadingButton, setLoadingButton] = useState<string | null>(null);

  const executeButton = async (
    buttonId: string,
    apiFn: () => Promise<Response>,
    opts?: { successMessage?: string },
  ) => {
    setLoadingButton(buttonId);
    const success = await execute(apiFn, opts);
    setLoadingButton(null);
    return success;
  };

  useEffect(() => {
    console.log("curEquipment", props.curEquipment);
  }, [props.curEquipment]);

  // useEffect(() => {
  //     console.log("curMissionObj", curMissionObj);
  // }, [curMissionObj])

  // useEffect(() => {
  //     // console.log(props.equipObject);
  //     // console.log(props.equipObject.topicPortion);
  //     // console.log(props.equipObject.topicPortion.replace(/\//g, ''));
  //     // console.log(convertToString(props.equipObject?.Orchestrator?.MissionProgress));
  //     // console.log(convertToString(props.equipObject?.Orchestrator?.MissionProgressGoal));
  //     // console.log(convertToString(props.equipObject?.Orchestrator?.MissionTimeLeft));
  // }, [props.equipObject]);

  // Function to convert an object with series of values to a single string
  function convertToString(obj: { [key: string]: string }): string {
    // Create an array to hold the characters
    const result: string[] = [];
    // Iterate over the keys in the object
    if (obj) {
      for (let i = 0; i < Object.keys(obj).length; i++) {
        // Push the value corresponding to each key into the result array
        result.push(obj[i.toString()]);
      }
      // Join the array into a single string
      return result.join("");
    } else {
      return "";
    }
  }

  function getTimeAfterSeconds(secondsAway: number): string {
    const currentDate = new Date(); // Get the current date and time
    currentDate.setSeconds(currentDate.getSeconds() + secondsAway); // Add the specified seconds

    // Format the time in a 12-hour format
    const options: Intl.DateTimeFormatOptions = {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    return currentDate.toLocaleString("en-US", options); // Return formatted time
  }

  function getNeatTimeFormat(amountOfSeconds: number): string {
    // Calculate hours, minutes, and seconds
    const hours = Math.floor(amountOfSeconds / 3600);
    const minutes = Math.floor((amountOfSeconds % 3600) / 60);
    const seconds = amountOfSeconds % 60;

    // Create an array to hold the parts of the time string
    const timeParts: string[] = [];

    // Add hours if present
    if (hours > 0) {
      timeParts.push(`${hours} hour${hours > 1 ? "s" : ""}`);
    }

    // Add minutes if present
    if (minutes > 0) {
      timeParts.push(`${minutes} min${minutes > 1 ? "s" : ""}`);
    }

    // Add seconds if present and no hours or minutes present
    if (seconds > 0 || timeParts.length === 0) {
      timeParts.push(`${seconds} sec${seconds > 1 ? "s" : ""}`);
    }

    // Join the parts with a space
    return timeParts.join(" ");
  }

  //     Autonomy Commands:
  //  - Machine Off
  // 	Org/Jobsite/Session/ADT/999/Dusty/Orchestrator/Command : MachineOff
  //  - Start Autonomy
  // 	Org/Jobsite/Session/ADT/999/Dusty/Orchestrator/Command : StartAutonomy
  // 	Org/Jobsite/Session/ADT/999/Dusty/Orchestrator/Guidance : Route Object (Path, path type)
  //  - Stop Autonomy
  // 	Org/Jobsite/Session/ADT/999/Dusty/Orchestrator/Command : StopAutonomy
  // 	Org/Jobsite/Session/ADT/999/Dusty/Orchestrator/Guidance : Null
  //  - Pause Autonomy
  // 	Org/Jobsite/Session/ADT/999/Dusty/Orchestrator/Command : PauseAutonomy
  //  - Resume Autonomy
  // 	Org/Jobsite/Session/ADT/999/Dusty/Orchestrator/Command : ResumeAutonomy

  // async function MachineOff() {
  //     console.log(props.currentTopicString + props.equipObject?.topicPortion.toString() + "/Orchestrator/Command");
  //     const requestDetails = { endpoint: '/Autonomy/MachineOff', message: 'MachineOff' };
  //     if (!requestDetails) return;

  //     // setLoading(true); // Set loading state to true

  //     try {
  //         // `http://localhost:3000${requestDetails.endpoint}`
  //         const response = await fetch(`/API/${requestDetails.endpoint}`, {
  //             method: 'POST',
  //             headers: {
  //                 'Content-Type': 'application/json',
  //             },
  //             body: JSON.stringify({
  //                 // currentTopicString: props.currentTopicString
  //                 currentTopicString: props.currentTopicString + props.equipObject?.topicPortion.toString()
  //             }), // Convert the pointsArray to JSON
  //         });

  //         if (!response.ok) {
  //             throw new Error('Network response was not ok');
  //         }

  //         // Handle response if necessary
  //         console.log(`Successfully sent ${requestDetails.message}:`, await response.json());
  //     } catch (error) {
  //         console.error('Error sending request:', error);
  //     } finally {
  //         // setLoading(false); // Reset loading state
  //     }
  // };
  // async function StartAutonomy() {
  //     console.log("curMissionObj", curMissionObj);
  //     console.log(props.currentTopicString + props.equipObject?.topicPortion.toString() + "/Orchestrator/Command");
  //     const requestDetails = { endpoint: '/Autonomy/StartAutonomy', message: 'StartAutonomy' };
  //     if (!requestDetails) return;

  //     // setLoading(true); // Set loading state to true

  //     try {
  //         // `http://localhost:3000${requestDetails.endpoint}`
  //         const response = await fetch(`/API/${requestDetails.endpoint}`, {
  //             method: 'POST',
  //             headers: {
  //                 'Content-Type': 'application/json',
  //             },
  //             body: JSON.stringify({
  //                 // currentTopicString: props.currentTopicString
  //                 currentTopicString: props.currentTopicString + props.equipObject?.topicPortion.toString(),
  //                 Guidance: JSON.stringify(curMissionObj?.guidanceRoute)
  //             }), // Convert the pointsArray to JSON
  //         });

  //         if (!response.ok) {
  //             throw new Error('Network response was not ok');
  //         }

  //         // Handle response if necessary
  //         console.log(`Successfully sent ${requestDetails.message}:`, await response.json());
  //     } catch (error) {
  //         console.error('Error sending request:', error);
  //     } finally {
  //         // setLoading(false); // Reset loading state
  //     }
  // };
  // async function StopAutonomy() {
  //     console.log(props.currentTopicString + props.equipObject?.topicPortion.toString() + "/Orchestrator/Command");
  //     const requestDetails = { endpoint: '/Autonomy/StopAutonomy', message: 'StopAutonomy' };
  //     if (!requestDetails) return;

  //     // setLoading(true); // Set loading state to true

  //     try {
  //         // `http://localhost:3000${requestDetails.endpoint}`
  //         const response = await fetch(`/API/${requestDetails.endpoint}`, {
  //             method: 'POST',
  //             headers: {
  //                 'Content-Type': 'application/json',
  //             },
  //             body: JSON.stringify({
  //                 // currentTopicString: props.currentTopicString
  //                 currentTopicString: props.currentTopicString + props.equipObject?.topicPortion.toString(),
  //                 Guidance: null
  //             }), // Convert the pointsArray to JSON
  //         });

  //         if (!response.ok) {
  //             throw new Error('Network response was not ok');
  //         }

  //         // Handle response if necessary
  //         console.log(`Successfully sent ${requestDetails.message}:`, await response.json());
  //     } catch (error) {
  //         console.error('Error sending request:', error);
  //     } finally {
  //         // setLoading(false); // Reset loading state
  //     }
  // };
  // async function PauseAutonomy() {
  //     console.log(props.currentTopicString + props.equipObject?.topicPortion.toString() + "/Orchestrator/Command");
  //     const requestDetails = { endpoint: '/Autonomy/PauseAutonomy', message: 'PauseAutonomy' };
  //     if (!requestDetails) return;

  //     // setLoading(true); // Set loading state to true

  //     try {
  //         // `http://localhost:3000${requestDetails.endpoint}`
  //         const response = await fetch(`/API/${requestDetails.endpoint}`, {
  //             method: 'POST',
  //             headers: {
  //                 'Content-Type': 'application/json',
  //             },
  //             body: JSON.stringify({
  //                 // currentTopicString: props.currentTopicString
  //                 currentTopicString: props.currentTopicString + props.equipObject?.topicPortion.toString()
  //             }), // Convert the pointsArray to JSON
  //         });

  //         if (!response.ok) {
  //             throw new Error('Network response was not ok');
  //         }

  //         // Handle response if necessary
  //         console.log(`Successfully sent ${requestDetails.message}:`, await response.json());
  //     } catch (error) {
  //         console.error('Error sending request:', error);
  //     } finally {
  //         // setLoading(false); // Reset loading state
  //     }
  // };
  // async function ResumeAutonomy() {
  //     console.log(props.currentTopicString + props.equipObject?.topicPortion.toString() + "/Orchestrator/Command");
  //     const requestDetails = { endpoint: '/Autonomy/ResumeAutonomy', message: 'ResumeAutonomy' };
  //     if (!requestDetails) return;

  //     // setLoading(true); // Set loading state to true

  //     try {
  //         // `http://localhost:3000${requestDetails.endpoint}`
  //         const response = await fetch(`/API/${requestDetails.endpoint}`, {
  //             method: 'POST',
  //             headers: {
  //                 'Content-Type': 'application/json',
  //             },
  //             body: JSON.stringify({
  //                 // currentTopicString: props.currentTopicString
  //                 currentTopicString: props.currentTopicString + props.equipObject?.topicPortion.toString()
  //             }), // Convert the pointsArray to JSON
  //         });

  //         if (!response.ok) {
  //             throw new Error('Network response was not ok');
  //         }

  //         // Handle response if necessary
  //         console.log(`Successfully sent ${requestDetails.message}:`, await response.json());
  //     } catch (error) {
  //         console.error('Error sending request:', error);
  //     } finally {
  //         // setLoading(false); // Reset loading state
  //     }
  // };

  function getErrorsList() {
    let tempErrorList: any = [];
    // Check if equipObj.errors and its errorsList exist
    if (
      props.equipObject?.errors?.errorsList &&
      Array.isArray(props.equipObject.errors.errorsList)
    ) {
      // Map over the errorsList to create DataItem components
      props.equipObject.errors.errorsList.map((error: any) => {
        // console.log("error",error);
        tempErrorList.push(
          <DataItem
            key={error.errorCode} // Ensure unique key for each item
            icon={<IconError size={32} sx={{ margin: "16px" }} />}
            title={error.errorCode} // Set the title to the error code
            subtitle={error.errorDescription} // Set subtitle to the error description
            about={error.errorLocation.toString()} // Set about to the error location
          />,
        );
      });
    }

    // Return an empty array if no errors are found
    // console.log("tempErrorList", tempErrorList);
    return tempErrorList;
  }

  // useEffect(() => {
  //     // console.log("props.equipObject.VehicleState.autonomy", props.equipObject.VehicleState.autonomy);
  //     let autonomyState = "Off";
  //     try {
  //         autonomyState = props.equipObject.VehicleState.autonomy;
  //         setAutonomyState(props.equipObject.VehicleState.autonomy.toString());
  //         setEngineState(props.equipObject.VehicleState.engine.toString());
  //     } catch { }
  //     if (autonomyState == "Off") {
  //         setAutonomyIcon(<StatusAutonomyOff icon={{ style: { width: "32px", height: "32px" } }} />);
  //         setAutonomyState("Off");
  //         setEngineState("Off");
  //     } else if (autonomyState == "Active") {
  //         setAutonomyIcon(<StatusAutonomyActive icon={{ style: { width: "32px", height: "32px" } }} />)
  //     } else if (autonomyState == "Ready") {
  //         setAutonomyIcon(<StatusAutonomyReady icon={{ style: { width: "32px", height: "32px" } }} />)
  //     } else if (autonomyState == "NotReady") {
  //         setAutonomyIcon(<StatusAutonomyNotReady icon={{ style: { width: "32px", height: "32px" } }} />)
  //     } else if (autonomyState == "Paused") {
  //         setAutonomyIcon(<StatusAutonomyReady icon={{ style: { width: "32px", height: "32px" } }} />)
  //     }
  // }, [props.autonomyStatus])

  function sendPauseMachine() {
    const url = "https://" + backendURI + "/Save/PauseMachine";
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        currentTopicString:
          props.currentTopicString +
          "SiteManager/Orchestrator/userId/" +
          props.equipObject.topicPortion.replace(/\//g, ""),
      }),
    });
  }

  function sendResumeMachine() {
    const url = "https://" + backendURI + "/Save/ResumeMachine";
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        currentTopicString:
          props.currentTopicString +
          "SiteManager/Orchestrator/userId/" +
          props.equipObject.topicPortion.replace(/\//g, ""),
      }),
    });
  }

  async function sendStopMachine() {
    setLoadingButton("stopMachine");
    await execute(() => sendPauseMachine(), { successMessage: "Pause command sent" });
    await execute(() => sendClearMachineTaskList(), { successMessage: "Clear tasks command sent" });
    setLoadingButton(null);
  }

  function sendSkipTask() {
    const url = "https://" + backendURI + "/Save/SkipTask";
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        currentTopicString:
          props.currentTopicString +
          "SiteManager/Orchestrator/SKIP_TASK/" +
          props.equipObject.topicPortion.replace(/\//g, ""),
      }),
    });
  }

  function sendClearMachineTaskList() {
    const url = "https://" + backendURI + "/Save/ClearMachineTaskList";
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        currentTopicString:
          props.currentTopicString +
          "SiteManager/Orchestrator/CLEAR_TASK_LIST/" +
          props.equipObject.topicPortion.replace(/\//g, ""),
      }),
    });
  }

  useEffect(() => {
    if (props.autonomyStatus == "ACTIVE") {
      setIsActive(true);
      setAutonomyState("Active");
      setEngineState("On");
      setAutonomyIcon(<StatusAutonomyActive size={32} />);
    } else if (props.autonomyStatus == "LOW_ENERGY_STATE") {
      setIsActive(true);
      setAutonomyState("Low Energy State");
      setEngineState("On");
      setAutonomyIcon(<StatusAutonomyReady size={32} />);
    } else if (props.autonomyStatus == "STANDBY") {
      setIsActive(true);
      setAutonomyState("Standby");
      setEngineState("On");
      setAutonomyIcon(<StatusAutonomyReady size={32} />);
    } else if (props.autonomyStatus == "OFF") {
      setIsActive(true);
      setAutonomyState("Off");
      setEngineState("Off");
      setAutonomyIcon(<StatusAutonomyOff size={32} />);
    } else if (props.autonomyStatus == "INVALID") {
      setIsActive(true);
      setAutonomyState("Invalid");
      setEngineState("Off");
      setAutonomyIcon(<StatusAutonomyOff size={32} />);
    } else {
      setIsActive(false);
      setAutonomyState("Off");
      setEngineState("Off");
      setAutonomyIcon(<StatusAutonomyOff size={32} />);
    }
    console.log(autonomyState + " : " + props.autonomyStatus);
  }, [props.autonomyStatus]);

  useEffect(() => {
    if (props.navigatorStatus == "OFF") {
      setNavigatorState("Off");
      setAutonomyIcon(<StatusAutonomyActive size={32} />);
    } else if (props.navigatorStatus == "GENERATING_PATH") {
      setNavigatorState("Low Energy State");
      setAutonomyIcon(<StatusAutonomyReady size={32} />);
    } else if (props.navigatorStatus == "READY") {
      setNavigatorState("Standby");
      setAutonomyIcon(<StatusAutonomyReady size={32} />);
    } else if (props.navigatorStatus == "ENGAGED") {
      setNavigatorState("Engaged");
      setAutonomyIcon(<StatusAutonomyOff size={32} />);
    } else if (props.navigatorStatus == "INTERRUPTED") {
      setNavigatorState("Interrupted");
      setAutonomyIcon(<StatusAutonomyOff size={32} />);
    } else {
      setNavigatorState("Off");
      setAutonomyIcon(<StatusAutonomyOff size={32} />);
    }
    console.log(navigatorState + " : " + props.navigatorStatus);
  }, [props.navigatorStatus]);

  useEffect(() => {
    if (
      autonomyState == "Active" ||
      autonomyState == "Low Energy State" ||
      autonomyState == "Standby"
    ) {
      // Autonomy is running
      setIsActive(true);
    } else {
      setIsActive(false);
    }
    if (
      curMissionObj.hasOwnProperty("missionName") &&
      (autonomyState == "Active" ||
        autonomyState == "Low Energy State" ||
        autonomyState == "Standby") &&
      engineState == "On" &&
      isWithinRange &&
      !hasErrors
    ) {
      console.log("setCanGiveCommand", true);
      setCanGiveCommand(true);
    } else {
      // if (!curMissionObj.hasOwnProperty("missionName")) {
      //     // No Mission Name
      //     console.log("Error, no Mission Name");
      // } else if (!(autonomyState == "Active" || autonomyState == "Low Energy State" || autonomyState == "Standby")) {
      //     // Mission is not
      //     console.log("")
      // } else if (engineState !== "On") {
      //     console.log("engineState", engineState);
      // } else if (!isWithinRange) {
      //     console.log("isWithinRange", isWithinRange);
      // } else if (hasErrors) {
      //     console.log("hasErrors", hasErrors);
      // }
      console.log("setCanGiveCommand", false);
      setCanGiveCommand(false);
    }
  }, [curMissionObj, autonomyState, engineState, isWithinRange, hasErrors]);

  // Add a function to toggle the ErrorWindow
  const toggleErrorWindow = () => {
    setErrorWindowOpen(!isErrorWindowOpen);
  };
  // Check if errors exist in the current mission object
  useEffect(() => {
    // console.log(props.equipObject);
    try {
      setHasErrors(
        props.equipObject?.errors?.errorsList && props.equipObject?.errors?.errorsList?.length > 0,
      );
      setErrorListItems(getErrorsList());
    } catch (error) {}
  }, [props.equipObject]);
  // const hasErrors = curMissionObj.errors && curMissionObj.errors.length > 0;

  // Haversine formula to calculate distance between two points on the Earth
  const haversineDistance = (lat1: number, lon1: number, lat2: number, lon2: number): number => {
    const R = 6371e3; // Radius of the Earth in meters
    const φ1 = (lat1 * Math.PI) / 180; // φ in radians
    const φ2 = (lat2 * Math.PI) / 180; // φ in radians
    const λ1 = (lon1 * Math.PI) / 180; // φ in radians
    const λ2 = (lon2 * Math.PI) / 180; // φ in radians
    const Δφ = ((lat2 - lat1) * Math.PI) / 180; // Δφ in radians
    const Δλ = ((lon2 - lon1) * Math.PI) / 180; // Δλ in radians
    // console.log("Δφ", Δφ);
    // console.log("Δλ", Δλ);

    const d =
      2 *
      R *
      Math.asin(
        Math.sqrt((1 - Math.cos(Δφ) + Math.cos(φ1) * Math.cos(φ2) * (1 - Math.cos(Δλ))) / 2),
      );
    // console.log("distance found",d);
    return d;

    // const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    //     Math.cos(φ1) * Math.cos(φ2) *
    //     Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    // const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    // return R * c; // Distance in meters
  };

  function checkIfInRange() {
    // Safely extract latitude and longitude from equipObject
    const equipLat =
      props.equipObject?.front?.axle?.center?.GlobalPose?.location?.latitude ??
      props.equipObject?.MachineState?.GlobalPose?.location?.latitude;
    const equipLon =
      props.equipObject?.front?.axle?.center?.GlobalPose?.location?.longitude ??
      props.equipObject?.MachineState?.GlobalPose?.location?.longitude;
    const userLat = props.userLocation?.latitude;
    const userLon = props.userLocation?.longitude;

    // Check if all necessary values are present
    if (
      equipLat !== undefined &&
      equipLon !== undefined &&
      userLat !== undefined &&
      userLon !== undefined
    ) {
      // Calculate the distance
      const distanceMeters = haversineDistance(equipLat, equipLon, userLat, userLon);
      const distanceFeet = distanceMeters * 3.28084; // Convert meters to feet
      // console.log("machine location", props.equipObject?.front_axle_center?.GlobalPose?.location);
      // console.log("user location", props.userLocation);
      // console.log("distanceFeet", distanceFeet);

      // Set the state based on the distance
      if (distanceFeet < 1500) {
        setIsWithinRange(true);
      } else {
        setIsWithinRange(false);
      }
    } else {
      // If any of the required values are missing, do not throw an error, simply set to false
      setIsWithinRange(false);
    }
  }

  useEffect(() => {
    checkIfInRange();
  }, [props.equipObject, props.userLocation]);

  function toggleSpoofLocation() {
    if (props.isSpoofing) {
      // Turn off spoofing — restore the saved original location
      props.setIsSpoofing(false);
      if (props.originalLocation) {
        props.setUserLocation({ ...props.originalLocation });
        console.log("[Spoof] Location restored to original:", props.originalLocation);
      }
      props.setOriginalLocation(null);
      // Also request fresh browser coords to keep it updated
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            props.setUserLocation({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            });
            console.log(
              "[Spoof] Fresh browser location obtained:",
              position.coords.latitude,
              position.coords.longitude,
            );
          },
          (err) => {
            console.warn(
              "[Spoof] Could not get fresh browser location, using saved original:",
              err.message,
            );
          },
        );
      }
    } else {
      // Save original location before spoofing
      props.setOriginalLocation(props.userLocation ? { ...props.userLocation } : null);
      console.log("[Spoof] Saved original location:", props.userLocation);

      // Spoof user location to ~3m from machine
      const equipLat =
        props.equipObject?.front?.axle?.center?.GlobalPose?.location?.latitude ??
        props.equipObject?.MachineState?.GlobalPose?.location?.latitude;
      const equipLon =
        props.equipObject?.front?.axle?.center?.GlobalPose?.location?.longitude ??
        props.equipObject?.MachineState?.GlobalPose?.location?.longitude;

      if (equipLat !== undefined && equipLon !== undefined) {
        const offsetLat = 0.000027; // ~3 meters north
        props.setUserLocation({
          latitude: equipLat + offsetLat,
          longitude: equipLon,
        });
        props.setIsSpoofing(true);
        console.log("[Spoof] Location spoofed to near machine:", equipLat + offsetLat, equipLon);
      } else {
        console.warn("[Spoof] Cannot spoof — machine location not available");
      }
    }
  }

  useEffect(() => {
    // console.log("props.equipObject", props.equipObject);
  }, [props.equipObject]);

  // useEffect(()=>{
  //     setCurMissionObj({});
  // },[props.curEquipment])

  function getMissionFromID(orgData: any, title: string): any | null {
    // Retrieve the missions from orgData using the existing getMissions function
    const missionsObject = getMissions(orgData);

    // Access the Missions object
    const missions = (missionsObject as any).Missions;

    // Search for the mission with the specified ID
    if (missions) {
      for (const missionId in missions) {
        const mission = missions[missionId];
        // console.log("MISSION ID: ", missionId);
        // console.log("Title: ", title);
        if (missionId === title) {
          // Compare missionId with the given ID
          return mission; // Return the found mission object
        }
      }
    }

    return null; // Return null if no mission is found with the given ID
  }

  function getMissions(orgData: any): object {
    // Recursive function to search for Missions in the object
    const findMissions = (obj: any): object | null => {
      // Check if the current object has a Missions key
      if (obj && typeof obj === "object") {
        if ("Missions" in obj) {
          return obj.Missions; // Return the Missions object if found
        }

        // Recursively search through each property in the object
        for (const key in obj) {
          const result = findMissions(obj[key]);
          if (result) {
            return result; // Return the result if Missions is found in the current branch
          }
        }
      }
      return null; // Return null if Missions is not found
    };

    const missions = findMissions(orgData);
    return missions ? { Missions: missions } : { Missions: {} }; // Return found missions or an empty object
  }

  function getMissionItem2(
    mission: any,
    missionId: string,
  ): {
    id: string;
    title: string;
    subtitle: string;
    Icon: JSX.Element;
  } {
    // Extract the necessary properties from the mission object
    // console.log(mission);
    // console.log("Mission Key: ", missionId);
    // let mission: any = Object.values(missionObject)[0];
    // const missionId = (Object.keys(missionObject)[0] as string) || '0'; // Use vehicleID or default to '0'
    const title = mission.missionName || "Unknown Mission";
    const subtitle = mission.missionDescription || "No description available";

    function scaleValue(
      value: number,
      originalMin: number,
      originalMax: number,
      newMin: number,
      newMax: number,
      isLatitude: boolean = false,
    ): number {
      // Scale the value from the original range to the new range
      const scaledValue =
        ((value - originalMin) * (newMax - newMin)) / (originalMax - originalMin) + newMin;

      // If scaling latitude, invert the value
      return isLatitude ? newMax - (scaledValue - newMin) : scaledValue;
    }

    // Define the new range
    const newMin = 10;
    const newMax = 190;

    // Get original bounds for scaling
    const originalLatValues: any = [];
    const originalLngValues: any = [];
    // console.log("mission", mission);
    // mission.Tasks && Object.values(mission.Tasks).forEach(task => {
    //     (task as any).route.points.forEach((point: any) => {
    //         originalLatValues.push(point.location.latitude);
    //         originalLngValues.push(point.location.longitude);
    //     });
    // });
    // console.log("mission", mission);
    // Resolve UUID-only tasks to full location data from jobsite attributes
    const resolvedTasks = resolveTaskLocations(mission.tasks || [], props.orgDataSession);
    if (mission.tasks) {
      // Collect all points from each task
      resolvedTasks.forEach((task: any) => {
        if (task.navigateItem) {
          // Assuming task.navigateItem is where the selected item is stored
          if (task?.action === "Navigate") {
            if (task.properties.location) {
              // allPoints.push({ location: task.properties.location });
              originalLatValues.push(task.properties.location.latitude);
              originalLngValues.push(task.properties.location.longitude);
            } else {
              const points = task.properties.points;
              points.forEach((point: any) => {
                // allPoints.push(point);
                originalLatValues.push(point.location.latitude);
                originalLngValues.push(point.location.longitude);
              });
            }
          }
        }
      });
      // Adding the first Task in the list again for visualizing repetition
      if (resolvedTasks[0]?.navigateItem) {
        // Assuming task.navigateItem is where the selected item is stored
        if (resolvedTasks[0]?.action === "Navigate") {
          if (resolvedTasks[0].properties.location) {
            // allPoints.push({ location: resolvedTasks[0].properties.location })
            originalLatValues.push(resolvedTasks[0].properties.location.latitude);
            originalLngValues.push(resolvedTasks[0].properties.location.longitude);
          } else {
            const points = resolvedTasks[0].properties.points;
            points.forEach((point: any) => {
              // allPoints.push(point);
              originalLatValues.push(point.location.latitude);
              originalLngValues.push(point.location.longitude);
            });
          }
        }
      }
    }

    // if (mission.hasOwnProperty("guidanceRoute")) {

    //     mission.guidanceRoute.points.forEach((point: any) => {
    //         originalLatValues.push(point.location.latitude);
    //         originalLngValues.push(point.location.longitude);
    //     });
    // }
    // console.log(originalLatValues);

    const latOriginalMin = Math.min(...originalLatValues);
    const latOriginalMax = Math.max(...originalLatValues);
    const lngOriginalMin = Math.min(...originalLngValues);
    const lngOriginalMax = Math.max(...originalLngValues);

    // Scale points for Polyline
    // const points = mission.Tasks ? Object.values(mission.Tasks).flatMap(task =>
    //     (task as any).route.points.map((point: any) => {
    //         const scaledLongitude = scaleValue(point.location.longitude, lngOriginalMin, lngOriginalMax, newMin, newMax);
    //         const scaledLatitude = scaleValue(point.location.latitude, latOriginalMin, latOriginalMax, newMin, newMax);
    //         return `${scaledLongitude},${scaledLatitude}`;
    //     })).join(' ') : '';

    // Scale points for Polyline
    const points =
      originalLatValues
        ?.map((lat: any, index: number) => {
          const scaledLongitude = scaleValue(
            originalLngValues[index],
            lngOriginalMin,
            lngOriginalMax,
            newMin,
            newMax,
          );
          const scaledLatitude = scaleValue(
            originalLatValues[index],
            latOriginalMin,
            latOriginalMax,
            newMin,
            newMax,
            true,
          );
          return `${scaledLongitude},${scaledLatitude}`;
        })
        .join(" ") || "";

    // Create the mission item object
    const missionItem = {
      id: missionId,
      title: title,
      subtitle: subtitle,
      Icon: <Polyline points={points} stroke="#3290ff" strokeWidth={4} />, // Use points to draw the Polyline
      onClick: async (thisEvent: any) => {
        setCurMissionObj(mission);
        // console.log("mission", mission);

        // THIS IS WHERE I SET THE TASKLIST TO THE CREATED TASKS FROM THE MISSION OBJECT
        let tempTaskList: any[] = [];

        // Looping through the number of repetitions for the mission
        for (let missionLap = 0; missionLap < mission.taskRepetitions; missionLap++) {
          // Collect all points from each task (use resolved tasks)
          resolvedTasks.forEach((task: any) => {
            if (task.navigateItem) {
              // Assuming task.navigateItem is where the selected item is stored
              if (task?.action === "Navigate") {
                if (task.properties.location) {
                  tempTaskList.push({
                    navigatorRequest: {
                      goalPose: {
                        location: task.properties.location,
                      },
                      bearing: task?.properties?.approachHeading | 0,
                    },
                    isToDump: false,
                  });
                } else {
                  tempTaskList.push({
                    navigatorRequest: {
                      staticPath: {
                        poses: task.properties.points,
                      },
                      isToDump: false,
                    },
                  });
                }
              }
            }
          });
        }

        setTaskList(tempTaskList);
      },
    };

    // console.log(points);

    return missionItem;
  }

  useEffect(() => {
    let theseMissions = getMissions(props.orgData);
    // console.log(theseMissions);
    setMissionsObjects(theseMissions);
  }, [props.orgData]);

  useEffect(() => {
    let myMissions: Item[] = [];
    // console.log(missionsObjects["Missions"]);
    if (missionsObjects) {
      let newMissionsObject: any = Object.values(missionsObjects)[0];
      if (newMissionsObject) {
        // console.log(Object.values(missionsObjects)[0]);
        for (const missionIndex in Object.values(newMissionsObject)) {
          // console.log(newMissionsObject);
          // console.log(missionsObjects[missionIndex]);
          myMissions.push(
            getMissionItem2(
              Object.values(newMissionsObject)[missionIndex],
              Object.keys(newMissionsObject)[missionIndex] as string,
            ),
          );
        }
      }
    }
    // for (const missionIndex in missionsObjects) {
    //     console.log(missionsObjects[missionIndex]);
    //     console.log(Object.values(missionsObjects)[0]);
    //     myMissions.push(getMissionItem(missionsObjects[missionIndex]));
    // }
    // console.log(myMissions);
    setMissions(myMissions);
    setFilteredMissions(myMissions);
  }, [missionsObjects]);

  const handleChange = (event: any, newValue: React.SetStateAction<string>): void => {
    setCurrentTab(newValue);
  };

  function getLocationsFromOrgData(orgData: any): any[] {
    const locations: any[] = []; // Array to hold found vehicle objects

    // Recursive function to search for routes in the object
    const findLocations = (obj: any) => {
      if (obj && typeof obj === "object") {
        for (const key in obj) {
          if (key === "Line") {
            locations.push({ location: obj[key], type: "Line" });
          } else if (key === "Shape") {
            locations.push({ location: obj[key], type: "Shape" });
          } else if (key === "Point") {
            locations.push({ location: obj[key], type: "Point" });
          } else {
            // Recursively search through the properties
            findLocations(obj[key]);
          }
        }
      }
    };

    // Start the recursive search
    findLocations(orgData);

    return locations; // Return the found vehicles wrapped in an object
  }

  useEffect(() => {
    setLocations(getLocationsFromOrgData(props.orgData));
  }, [props.orgData]);

  function getPolyLineItemFromPoints(points: any | null, type: string): any {
    // Use shared uniform-scale utility to preserve aspect ratio
    const newPoints = scaleGeoPointsToSvg(points);

    if (type === "Shape") {
      return <Polygon points={newPoints} stroke="#3290ff" strokeWidth={4} />; // Return the array of route items
    } else if (type === "Line") {
      return <Polyline points={newPoints} stroke="#3290ff" strokeWidth={6} />; // Return the array of route items
    } else {
      return (
        <IconMarkerEmpty
          size={25}
          style={{
            position: "relative",
            top: "0px",
            minHeight: "25px",
            minWidth: "25px",
            height: "auto",
            width: "auto",
          }}
        />
      ); // Return the array of route items
    }
  }

  useEffect(() => {
    // [{
    //     onClick: () => {},
    //     id: '0',
    //     title: 'From Loading to Dump Path',
    //     subtitle: 'Navigable Path',
    //     Icon:
    //         <Polyline points="10,150 30,130 50,120 70,110 90,100 110,120 130,130 150,140 170,130 190,150" stroke="#3290ff" strokeWidth={4} />,
    // }]
    let tempLocationItems: any[] = [];
    // console.log(locations);
    locations?.map((location, index, locationsArray) => {
      if (!location.location) return;
      let keys = Object.keys(location.location);
      keys.map((key: any, keyIndex: number) => {
        let entity = location.location[key];
        let thisIcon: any = <></>;
        // <Polyline points="10,150 30,130 50,120 70,110 90,100 110,120 130,130 150,140 170,130 190,150" stroke="#3290ff" strokeWidth={4} />
        // let key = Object.keys(location.location)[0];
        thisIcon = getPolyLineItemFromPoints(entity?.points, location?.type) || <></>;

        if (location.type === "Shape") {
          tempLocationItems.push({
            onClick: () => {
              // Note that the points array is just entity.points
              // console.log(entity)
              // This should find the center of the zone, and then update the taskList to be just this navigation task
              setTaskList([getTaskFromPoints([getCenterOfZone(entity.points)], "Point")]);
            },
            id: index,
            title: key || "",
            subtitle: entity?.zoneType || "",
            Icon: thisIcon,
          });
        } else if (location.type === "Line") {
          tempLocationItems.push({
            onClick: () => {
              // This should create and set a line mission task
              // console.log(entity)
              setTaskList([getTaskFromPoints(entity.points, "Line")]);
            },
            id: index,
            title: key || "",
            subtitle: entity?.pathType || "",
            Icon: thisIcon,
          });
        } else if (location.type === "Point") {
          tempLocationItems.push({
            onClick: () => {
              // This should create a navigation task to the point
              let thisPoint = [{ location: entity.location }];
              setTaskList([
                getTaskFromPoints(
                  [
                    {
                      location: entity.location,
                      bearing: entity?.approachHeading,
                    },
                  ],
                  "Point",
                ),
              ]);
            },
            id: index,
            title: key || "",
            subtitle: entity?.pointType || "",
            Icon: thisIcon,
          });
        }
      });
    });
    setLocationItems(tempLocationItems);
  }, [locations]);

  function getCenterOfZone(pointsArray: any[]) {
    let latSum = 0;
    let lngSum = 0;
    let numOfPoints = 0;
    pointsArray.map((point, pointIndex) => {
      latSum += point.location.latitude;
      lngSum += point.location.longitude;
      numOfPoints++;
    });
    return {
      location: {
        latitude: latSum / numOfPoints,
        longitude: lngSum / numOfPoints,
      },
    };
  }

  function getTaskFromPoints(pointsArray: any, entityType: string) {
    if (entityType === "Line") {
      return {
        navigatorRequest: {
          staticPath: {
            poses: pointsArray,
          },
          isToDump: false,
        },
      };
    } else if (entityType === "Point") {
      // This assumes a single point in a
      console.log(pointsArray);
      return {
        navigatorRequest: {
          goalPose: pointsArray[0],
        },
        isToDump: false,
      };
    }
  }

  function publishMission() {
    return fetch(`/API/Save/AddMissionNew`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        taskArray: taskList,
        currentTopicString:
          props.currentTopicString
            .replace(/\/(.*?\/)?/, (match: string) => match.replace(/\//, "_"))
            .replace(/\/(.*?\/)?/, (match: string) => match.replace(/\//, "_")) +
          "SiteManager/Orchestrator/TaskList/" +
          props.equipObject.topicPortion.replace(/\//g, ""),
      }),
    });
  }

  const handleSwipe = () => {
    if (taskList.length > 0) {
      execute(() => publishMission(), { successMessage: "Mission command sent" });
    }
  };

  const setDumpRequest = () => {
    const topicString =
      props.currentTopicString +
      "SiteManager/1/TaskList/" +
      props.equipObject.topicPortion.replace(/\//g, "_");

    return fetch(`/API/Save/AddMissionNew`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        taskArray: [{ dumpRequest: {} }],
        currentTopicString: topicString,
      }),
    });
  };

  const setWorkOn = () => {
    const topicString =
      props.currentTopicString +
      "SiteManager/1/TaskList/" +
      props.equipObject.topicPortion.replace(/\//g, "_");

    return fetch(`/API/Save/AddMissionNew`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        taskArray: [{ workRequest: { request: 1 } }],
        currentTopicString: topicString,
      }),
    });
  };

  const setWorkOff = () => {
    return fetch(`/API/Save/AddMissionNew`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        taskArray: [{ workRequest: { request: 0 } }],
        currentTopicString:
          props.currentTopicString +
          "SiteManager/1/TaskList/" +
          props.equipObject.topicPortion.replace(/\//g, "_"),
      }),
    });
  };

  const OccupancyGridWalkAround = () => {
    return fetch(`/API/Save/Occupancy`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        time: 0.0, // Note this time is not used
        currentTopicString:
          props.currentTopicString +
          props.curEquipment.id +
          `/Orchestrator/OccupancyGridWalkAround`,
      }),
    });
  };

  const OccupancyGridReset = () => {
    return fetch(`/API/Save/Occupancy`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        time: 0.0, // Note this time is not used
        currentTopicString:
          props.currentTopicString + props.curEquipment.id + `/Orchestrator/OccupancyGridReset`,
      }),
    });
  };

  // Clears only this machine's geospatial model. The jobsite-wide equivalent is
  // the Attributes tab's "Clear Attributes" button.
  const resetWorksite = () => {
    return fetch(`/API/Save/ResetWorksite`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        currentTopicString: props.currentTopicString + props.curEquipment.id + `/Reset_Worksite`,
      }),
    });
  };

  const handleLoaderAllowEnter = () => {
    return fetch(`https://` + backendURI + `/Save/LoaderMessage`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        uuid: "cue-000",
        horn_pattern: "",
        light_pattern: "",
        name: "Enter Load",
        currentTopicString: props.currentTopicString + "OrchestratorLoader/Cue",
      }),
    });
  };

  const handleLoaderDone = () => {
    return fetch(`https://` + backendURI + `/Save/LoaderMessage`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        uuid: "cue-002",
        horn_pattern: "",
        light_pattern: "",
        name: "Done Loading",
        currentTopicString: props.currentTopicString + "OrchestratorLoader/Cue",
      }),
    });
  };

  const clearTasksFooterActions: FooterAction[] = [
    {
      title: "Cancel",
      variant: "secondary",
      onClick: () => setShowClearTasksConfirm(false),
    },
    {
      title: "Clear Tasks",
      variant: "primary",
      loading: loadingButton === "clearTasks",
      disabled: loadingButton !== null,
      onClick: async () => {
        setLoadingButton("clearTasks");
        const success = await execute(() => sendClearMachineTaskList(), {
          successMessage: "Clear tasks command sent",
        });
        setLoadingButton(null);
        if (success) setShowClearTasksConfirm(false);
      },
    },
  ];

  return (
    <>
      <HeartbeatTimeline currentTopicString={props.currentTopicString} />
      <div className="subpanelDiv">
        {/* <div className='SectionTitle'>Mission</div>
                <div className='VehicleSelection'>
                    <DropdownMenu
                        // buttonTitle={mission ? mission.title : "Select a Guidance Path"}
                        buttonTitle={curMissionObj.hasOwnProperty("missionName") ? curMissionObj.missionName : "Select a Mission"}
                        // guidanceRouteId
                        items={missions}
                        onClick={() => {
                            // console.log("clicked a mission route Item"); 
                        }}
                    />
                </div>

                <Button
                    // onClick={PauseAutonomy}
                    onClick={handleSwipe}
                    startIcon={<IconAutomation icon={{ style: { width: "24px", height: "24px" } }} />}
                    variant="select"
                    style={{ height: "40px", width: "356px", margin: "16px", border: "rgba(6, 138, 252, 1)", backgroundColor: "#fff" }}
                >
                    Send on Mission
                </Button> */}

        {hasPermission(role, "LOCATION_SPOOFING", orgName) ? (
          <Button
            onClick={toggleSpoofLocation}
            startIcon={<IconMarkerEmpty size={24} />}
            variant="select"
            style={{
              height: "40px",
              width: "356px",
              margin: "16px",
              border: props.isSpoofing ? "2px solid #1B5E20" : "rgba(6, 138, 252, 1)",
              backgroundColor: props.isSpoofing ? "#4CAF50" : "#fff",
              color: props.isSpoofing ? "#fff" : "inherit",
              boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.16)",
            }}
          >
            {props.isSpoofing ? "Stop Spoofing Location" : "Spoof Location"}
          </Button>
        ) : (
          <div
            style={{
              margin: "16px",
              padding: "12px 16px",
              backgroundColor: "#FFF3E0",
              border: "1px solid #FFB74D",
              borderRadius: "4px",
              color: "#E65100",
              fontSize: "14px",
            }}
          >
            Location spoofing is disabled for the current organization.
          </div>
        )}

        <div className="SectionTitle">Loader Interface</div>

        <Button
          onClick={() =>
            executeButton("enterLoadZone", () => handleLoaderAllowEnter(), { successMessage: "Enter zone command sent" })
          }
          startIcon={<IconAutomation size={24} />}
          variant="select"
          loading={loadingButton === "enterLoadZone"}
          disabled={loadingButton !== null}
          style={{
            height: "40px",
            width: "356px",
            margin: "16px",
            border: "rgba(6, 138, 252, 1)",
            backgroundColor: "#fff",
          }}
        >
          Enter Load Zone
        </Button>

        <Button
          onClick={() => executeButton("doneLoading", () => handleLoaderDone(), { successMessage: "Done loading command sent" })}
          startIcon={<IconAutomation size={24} />}
          variant="select"
          loading={loadingButton === "doneLoading"}
          disabled={loadingButton !== null}
          style={{
            height: "40px",
            width: "356px",
            margin: "16px",
            border: "rgba(6, 138, 252, 1)",
            backgroundColor: "#fff",
          }}
        >
          Done Loading
        </Button>

        <br />
        <br />

        <div className="SectionTitle">Locations</div>
        <div className="VehicleSelection">
          <DropdownMenu
            // buttonTitle={mission ? mission.title : "Select a Guidance Path"}
            buttonTitle={
              curMissionObj.hasOwnProperty("missionName")
                ? curMissionObj.missionName
                : "Select a Location"
            }
            // guidanceRouteId
            disabled={true}
            items={locationItems}
            onClick={() => {
              // console.log("clicked a mission route Item");
            }}
          />
        </div>

        <Button
          onClick={() =>
            executeButton("walkAround", () => OccupancyGridWalkAround(), { successMessage: "Walk around command sent" })
          }
          startIcon={<IconAutomation size={24} />}
          variant="select"
          loading={loadingButton === "walkAround"}
          disabled={loadingButton !== null}
          style={{
            height: "40px",
            width: "356px",
            margin: "16px",
            border: "rgba(6, 138, 252, 1)",
            backgroundColor: "#fff",
            boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.16)",
          }}
        >
          Walk Around Clear
        </Button>

        <Button
          onClick={() => executeButton("resume", () => sendResumeMachine(), { successMessage: "Resume command sent" })}
          startIcon={<StatusEquipmentWorking size={24} />}
          variant="select"
          loading={loadingButton === "resume"}
          disabled={loadingButton !== null}
          style={{
            height: "40px",
            width: "356px",
            margin: "16px",
            border: "rgba(6, 138, 252, 1)",
            backgroundColor: "#fff",
            boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.16)",
          }}
        >
          Resume
        </Button>

        <Button
          onClick={() => executeButton("pause", () => sendPauseMachine(), { successMessage: "Pause command sent" })}
          startIcon={<IconPause size={24} />}
          variant="select"
          loading={loadingButton === "pause"}
          disabled={loadingButton !== null}
          style={{
            height: "40px",
            width: "356px",
            margin: "16px",
            border: "rgba(6, 138, 252, 1)",
            backgroundColor: "#fff",
            boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.16)",
          }}
        >
          Pause
        </Button>

        <Button
          onClick={() => executeButton("skipTask", () => sendSkipTask(), { successMessage: "Skip task command sent" })}
          startIcon={<IconRefresh size={24} />}
          variant="select"
          loading={loadingButton === "skipTask"}
          disabled={loadingButton !== null}
          style={{
            height: "40px",
            width: "356px",
            margin: "16px",
            border: "rgba(6, 138, 252, 1)",
            backgroundColor: "#fff",
            boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.16)",
          }}
        >
          Skip Task
        </Button>

        <Button
          onClick={() => executeButton("dumpTask", () => setDumpRequest(), { successMessage: "Dump task command sent" })}
          startIcon={<IconAutomation size={24} />}
          variant="select"
          loading={loadingButton === "dumpTask"}
          disabled={loadingButton !== null}
          style={{
            height: "40px",
            width: "356px",
            margin: "16px",
            border: "rgba(6, 138, 252, 1)",
            backgroundColor: "#fff",
            boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.16)",
          }}
        >
          Dump Task
        </Button>

        <Button
          onClick={() => setShowClearTasksConfirm(true)}
          startIcon={<IconRefresh size={24} />}
          variant="select"
          disabled={loadingButton !== null}
          style={{
            height: "40px",
            width: "356px",
            margin: "16px",
            border: "rgba(6, 138, 252, 1)",
            backgroundColor: "#fff",
            boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.16)",
          }}
        >
          Clear Tasks
        </Button>

        <Button
          onClick={() => executeButton("gridReset", () => OccupancyGridReset(), { successMessage: "Grid reset command sent" })}
          startIcon={<IconAutomation size={24} />}
          variant="select"
          loading={loadingButton === "gridReset"}
          disabled={loadingButton !== null}
          style={{
            height: "40px",
            width: "356px",
            margin: "16px",
            border: "rgba(6, 138, 252, 1)",
            backgroundColor: "#fff",
            boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.16)",
          }}
        >
          Grid Reset
        </Button>

        <Button
          onClick={() =>
            executeButton("resetWorksite", () => resetWorksite(), {
              successMessage: "Reset worksite command sent",
            })
          }
          startIcon={<IconAutomation size={24} />}
          variant="select"
          loading={loadingButton === "resetWorksite"}
          disabled={loadingButton !== null}
          style={{
            height: "40px",
            width: "356px",
            margin: "16px",
            border: "rgba(6, 138, 252, 1)",
            backgroundColor: "#fff",
            boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.16)",
          }}
        >
          Clear Worksite
        </Button>

        <Button
          onClick={() => executeButton("workOn", () => setWorkOn(), { successMessage: "Work on command sent" })}
          startIcon={<IconAutomation size={24} />}
          variant="select"
          loading={loadingButton === "workOn"}
          disabled={loadingButton !== null}
          style={{
            height: "40px",
            width: "356px",
            margin: "16px",
            border: "rgba(6, 138, 252, 1)",
            backgroundColor: "#fff",
            boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.16)",
          }}
        >
          Work On
        </Button>

        <Button
          onClick={() => executeButton("workOff", () => setWorkOff(), { successMessage: "Work off command sent" })}
          startIcon={<IconAutomation size={24} />}
          variant="select"
          loading={loadingButton === "workOff"}
          disabled={loadingButton !== null}
          style={{
            height: "40px",
            width: "356px",
            margin: "16px",
            border: "rgba(6, 138, 252, 1)",
            backgroundColor: "#fff",
            boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.16)",
          }}
        >
          Work Off
        </Button>

        <Button
          onClick={handleSwipe}
          startIcon={<IconAutomation size={24} />}
          variant="select"
          style={{
            height: "40px",
            width: "356px",
            margin: "16px",
            border: "rgba(6, 138, 252, 1)",
            backgroundColor: "#fff",
            boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.16)",
          }}
          disabled={true}
        >
          Send to Location
        </Button>

        <Button
          onClick={() => executeButton("clearAutonomyLogs", async () => {
            const vehiclePortion = props.equipObject?.topicPortion;
            if (!props.currentTopicString || !vehiclePortion) return new Response(null, { status: 400 });
            const cleanTopic = props.currentTopicString.replace(/\/+$/, "").replace(/\//g, "_");
            const cleanVehicle = vehiclePortion.replace(/\//g, "_");
            const machineIdentifier = `${cleanTopic}_${cleanVehicle}`;
            return fetch("/API/AutonomyLogs/clear", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              credentials: "include",
              body: JSON.stringify({ machineIdentifier }),
            });
          }, { successMessage: "Autonomy logs cleared" })}
          startIcon={<IconRefresh size={24} />}
          variant="select"
          loading={loadingButton === "clearAutonomyLogs"}
          disabled={loadingButton !== null}
          style={{
            height: "40px",
            width: "356px",
            margin: "16px",
            border: "1px solid #d32f2f",
            backgroundColor: "#fff",
            color: "#d32f2f",
            boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.16)",
          }}
        >
          Clear Autonomy Logs
        </Button>
      </div>
      <Dialog
        footerActions={clearTasksFooterActions}
        closeHandler={() => setShowClearTasksConfirm(false)}
        open={showClearTasksConfirm}
        title="Clear Tasks"
        width="sm"
      >
        Are you sure you want to clear all tasks? This action cannot be undone.
      </Dialog>
    </>
  );
};

export default RightNow;
